import React from 'react';
import { Icon } from '@iconify/react';

function NoData({ message, caption }) {
  return (
    <div className="flex items-center justify-center min-h-[200px] py-8">
      <div className="text-center">
        <Icon 
          icon="fluent:document-dismiss-24-regular" 
          width="64" 
          height="64" 
          className="text-gray-300 mb-3 mx-auto" 
        />
        <h5 className="text-gray-500 font-medium">{message || caption || 'No Data Available'}</h5>
      </div>
    </div>
  );
}

export default NoData;
